export default function Services() {
  const services = [
    {
      icon: 'ri-home-heart-line',
      title: '日常生活支援',
      description: 'お買い物の付き添いや、お掃除、お食事の準備など、日々の暮らしをサポートします。移動支援や見守りサービスも提供しています。',
      bgColor: 'bg-pink-50',
      iconColor: 'text-pink-500',
      link: '/daily-support'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '心のケア・生活相談',
      description: 'お話し相手や、日々の不安や悩みのご相談まで、心に寄り添います。一人ひとりの心の拠り所となるサポートを大切にしています。',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-500',
      link: null
    },
    {
      icon: 'ri-hand-heart-line',
      title: '家事援助サービス',
      description: '洗濯や調理、お部屋の整理整頓など、家事全般をお手伝いします。買い物代行や食事準備も承ります。',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-500',
      link: null
    }
  ];

  const handleServiceClick = (link: string | null) => {
    if (link) {
      window.REACT_APP_NAVIGATE(link);
    }
  };

  return (
    <section id="services" className="py-20 px-6 bg-gradient-to-b from-orange-50/30 to-white">
      <div className="max-w-7xl mx-auto">
        {/* タイトルエリア */}
        <div className="mb-16">
          <p className="text-sm font-light text-gray-400 mb-2 tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>SERVICES</p>
          <h3 className="text-4xl md:text-5xl font-black text-gray-800 leading-tight" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
            私たちができる<br />
            まごころのサポート
          </h3>
        </div>

        {/* サービスカード */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              onClick={() => handleServiceClick(service.link)}
              className={`${service.bgColor} rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer`}
            >
              <div className={`w-14 h-14 flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-4xl ${service.iconColor}`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                {service.title}
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                {service.description}
              </p>
              {service.link && (
                <div className="mt-4 flex items-center gap-2 text-pink-500 font-semibold text-sm">
                  詳しく見る
                  <i className="ri-arrow-right-line"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 料金の目安 */}
        <div className="mt-12 bg-gradient-to-r from-orange-50 to-pink-50 rounded-3xl px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
              <i className="ri-price-tag-3-line text-2xl text-orange-500"></i>
            </div>
            <div>
              <p className="text-xs font-light text-gray-500 tracking-widest mb-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>ご利用料金の目安</p>
              <p className="text-2xl font-black text-gray-800" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
                1時間あたり <span className="text-orange-500">¥3,850</span>
                <span className="text-sm font-normal text-gray-500 ml-2">（税込）</span>
              </p>
            </div>
          </div>
          <p className="text-sm text-gray-500 font-light leading-relaxed text-center md:text-right" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            ご利用内容・時間によって異なる場合があります。<br />
            詳しくはお気軽にお問い合わせください。
          </p>
        </div>

      </div>
    </section>
  );
}
